export default "/images/cmmc_compliance__page_heading.png";